export default {
  title: 'Ajuda',
};
